import React, { useState, useEffect, useMemo } from "react";
import './Buffs.css';
import BuffElement from "./BuffElement";

function BuffPanel({ buffs }) {
    const [currentTime, setCurrentTime] = useState(Date.now());
    
    // Update current time every second
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(Date.now());
        }, 1000);
        
        return () => clearInterval(intervalId);
    }, []);

    // Calculate remaining durations for each buff
    const buffsWithRemainingTime = useMemo(() => {
        return buffs.map(buff => ({
            ...buff,
            remainingTime: buff.duration === -1 ? -1 : Math.max(0, buff.duration - (currentTime - buff.createdAt))
        }));
    }, [buffs, currentTime]);

    // Filter out expired buffs
    const activeBuffs = useMemo(() => {
        return buffsWithRemainingTime.filter(buff => 
            buff.duration === -1 || buff.remainingTime > 0
        );
    }, [buffsWithRemainingTime]);

    const renderedBuffs = useMemo(() => {
        return activeBuffs.map((buff) => (
            <BuffElement 
                key={`${buff.uuid}-${buff.createdAt}`} 
                buff={buff} 
                remainingTime={buff.remainingTime}
            />
        ));
    }, [activeBuffs]);

    if (activeBuffs.length === 0) {
        return null;
    }

    return (
        <div className="buff-list">
            {renderedBuffs}
        </div>
    );
}

export default React.memo(BuffPanel);